import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from '../../fetch.js';
import { baseUrl, customHeaders, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { GET_FILES_SUMMARY, GET_FILES_SUMMARY_SUCCESS, GET_FILES_SUMMARY_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* getFilesSummary({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/file-summary`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({ type: GET_FILES_SUMMARY_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: GET_FILES_SUMMARY_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: GET_FILES_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetFilesSummary() {
  yield takeEvery(GET_FILES_SUMMARY, getFilesSummary);
}

function* getFilesSummarySaga() {
  yield all([fork(watchGetFilesSummary)]);
}

export default getFilesSummarySaga;
